import { useMediaQuery } from 'react-responsive';
import { breakpoints } from './utils/breakpoints';

export const Default = ({ children }) => {
	const isNotMobile = useMediaQuery({ minWidth: breakpoints.md.min });
	return isNotMobile ? children : null;
};
